import { BookingEmbed } from "../components/booking/BookingEmbed";
import { Reveal } from "../components/Reveal";
import { useTitle } from "../hooks/useTitle";

export default function BookingPage() {
  useTitle("Book Your Appointment | HairByYaya");

  return (
    <div className="px-5 pb-24 pt-28 md:pt-36" data-testid="booking-page">
      <Reveal className="mx-auto mb-12 max-w-6xl">
        <p className="font-script text-3xl text-hotpink">the booking room</p>
        <h1 className="mt-2 font-serif text-4xl md:text-6xl">
          Book Your Appointment
        </h1>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/55">
          Pick a style, choose your time, and secure your spot — all in a few
          taps.
        </p>
        <p className="mt-3 text-[11px] text-white/35">
          Prototype booking experience — simulated availability and deposit. No
          real appointment or payment is created.
        </p>
      </Reveal>
      <BookingEmbed />
    </div>
  );
}

